/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import {
	LatestNewsSectionFragment,
	CosmosEnumLatestNewsVariants,
	CosmosEnumBlogCardsMaxSize,
} from "@cosmos/hygraph-schema";
import {
	BlogCardProps,
	BlogCardsSection,
	FeedCardOrganism,
	FeedItem,
	NewsCardProps,
	NewsCardsSection,
} from "@components/elements";
import { useCosmosComponentContext } from "@components/context";
import { useLocale } from "@epic-mw/i18n";
import { FeaturedBlogCardsSection } from "./FeaturedBlogCards.section";

interface ExternalLatestNewsData {
	cards?: BlogCardProps[] | NewsCardProps[] | FeedItem[] | null;
}

export type LatestNewsSectionAndExternalProps = LatestNewsSectionFragment & ExternalLatestNewsData;

export const LatestNewsSection = ({
	config,
	cards = [],
	featuredLabel,
	latestNewsVariant,
}: LatestNewsSectionAndExternalProps): React.JSX.Element | null => {
	const locale = useLocale();
	const { feedBrand, locales } = useCosmosComponentContext();

	if (!cards?.length) return null;
	switch (latestNewsVariant) {
		case CosmosEnumLatestNewsVariants.Large5: {
			return (
				<FeaturedBlogCardsSection
					__typename="CosmosSectionBlogCard"
					id=""
					config={config}
					cards={cards.slice(0, 5) as BlogCardProps[]}
				/>
			);
		}
		case CosmosEnumLatestNewsVariants.MediumFlipFeatured10: {
			return (
				<FeedCardOrganism
					locale={locale}
					locales={locales}
					items={cards.slice(0, 10) as FeedItem[]}
					featuredLabel={featuredLabel}
					enableAnimate={false}
					flipFeatured={true}
					currentBrand={feedBrand}
				/>
			);
		}
		case CosmosEnumLatestNewsVariants.Medium3: {
			return (
				<BlogCardsSection
					config={config}
					cards={cards.slice(0, 3) as BlogCardProps[]}
					maxSize={CosmosEnumBlogCardsMaxSize.Three}
				/>
			);
		}
		case CosmosEnumLatestNewsVariants.Small4: {
			return <NewsCardsSection config={config} cards={cards.slice(0, 4) as NewsCardProps[]} maxCards={4} />;
		}
		case CosmosEnumLatestNewsVariants.Medium4Up: {
			return (
				<BlogCardsSection
					config={config}
					cards={cards.slice(0, 4) as BlogCardProps[]}
					maxSize={CosmosEnumBlogCardsMaxSize.Four}
				/>
			);
		}
		default: {
			return <NewsCardsSection config={config} cards={cards.slice(0, 2) as NewsCardProps[]} maxCards={2} />;
		}
	}
};
